module.exports = __webpack_public_path__ + "img/ignore.c7620cd2.svg";